export default __webpack_public_path__ + "static/media/Snd_q1.c1fb4208.mp3";